module.exports = __webpack_public_path__ + "bfb9af3da6845606194f7c10ee3f7994.pdf";